import {DocumentComplementaireDto, IFormationWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class DocumentsComplementairesResolver implements Resolve<Array<DocumentComplementaireDto>> {

  constructor(private formationWebService: IFormationWebServiceClient) {
  }

  resolve() {
    return this.formationWebService.findAllDocumentsComplementaires();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/commande/documents-complementaires.resolver.ts